import type { ObjectLike } from '@skedulo/horizon-types'
import { createGlobalContext } from '../registry'

/**
 * Session metadata returned by the Skedulo `/custom/usermetadata` endpoint —
 * the richer view of the current user that sits alongside the thin `Users`
 * resource object. Populated asynchronously by `UserProvider`; fields may be
 * `null` or `undefined` depending on the tenant and user profile.
 */
export interface UserMetadata {
  id: string
  email: string
  username: string
  fullName: string
  orgName: string
  isSkeduloScheduler: boolean | null | undefined
  isSkeduloUser: boolean | null | undefined
  isSkeduloAdmin: boolean | null | undefined
  smallPhotoUrl: string | null | undefined
  category: string | null | undefined
  resourceId: string | null | undefined
  latitude: number | null | undefined
  longitude: number | null | undefined
  address: string | null | undefined
  timezone: string | null | undefined
  country: string | null | undefined
}

export interface UserContextValue {
  user?: ObjectLike & { Name?: string }
  /** Skedulo user metadata (timezone, role flags, resourceId, ...). Populated asynchronously, independent of `loading`. */
  metadata?: UserMetadata
  /** `true` while the `Users` resource / user object are loading. */
  loading: boolean
  /** `true` while the `/custom/usermetadata` fetch is in flight. Tracked separately so consumers that only need `user` are not blocked by the metadata call. */
  metadataLoading: boolean
}

export const UserContext = createGlobalContext<UserContextValue>(
  'UserContext',
  {
    user: undefined,
    metadata: undefined,
    loading: false,
    metadataLoading: false,
  },
)
